import { Component, Input } from '@angular/core';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'psc-textarea',
  templateUrl: './textarea.component.html'
})
export class TextareaComponent  extends InputWrapperComponent<string>{

  @Input() placeholder: string;
  @Input() readonly = false;
  @Input() format: string;
  @Input() rows: number = 10;
  @Input() cols: number = 30;

}
